<template>
  <div class="password-verifier">
    <div class="password-verifier__item">
      <div class="password-verifier__checkbox-wrapper">
        <div
          :class="[
            'password-verifier__checkbox',
            hasNumber && 'password-verifier__checkbox--checked',
          ]"
        >
          <CheckIcon
            size="14"
            v-if="hasNumber"
            class="password-verifier__check"
          />
        </div>
      </div>
      <span
        :class="[
          'password-verifier__detail',
          hasNumber && 'password-verifier__detail--valid',
        ]"
        >One number</span
      >
    </div>
    <div class="password-verifier__item">
      <div class="password-verifier__checkbox-wrapper">
        <div
          :class="[
            'password-verifier__checkbox',
            hasUppercase && 'password-verifier__checkbox--checked',
          ]"
        >
          <CheckIcon
            size="14"
            v-if="hasUppercase"
            class="password-verifier__check"
          />
        </div>
      </div>
      <span
        :class="[
          'password-verifier__detail',
          hasUppercase && 'password-verifier__detail--valid',
        ]"
        >One uppercase letter</span
      >
    </div>
    <div class="password-verifier__item">
      <div class="password-verifier__checkbox-wrapper">
        <div
          :class="[
            'password-verifier__checkbox',
            hasLowercase && 'password-verifier__checkbox--checked',
          ]"
        >
          <CheckIcon
            size="14"
            v-if="hasLowercase"
            class="password-verifier__check"
          />
        </div>
      </div>
      <span
        :class="[
          'password-verifier__detail',
          hasLowercase && 'password-verifier__detail--valid',
        ]"
        >One lowercase letter</span
      >
    </div>
    <div class="password-verifier__item">
      <div class="password-verifier__checkbox-wrapper">
        <div
          :class="[
            'password-verifier__checkbox',
            hasLength && 'password-verifier__checkbox--checked',
          ]"
        >
          <CheckIcon
            size="14"
            v-if="hasLength"
            class="password-verifier__check"
          />
        </div>
      </div>
      <span
        :class="[
          'password-verifier__detail',
          hasLength && 'password-verifier__detail--valid',
        ]"
        >Eight characters length</span
      >
    </div>
    <div class="password-verifier__item">
      <div class="password-verifier__checkbox-wrapper">
        <div
          :class="[
            'password-verifier__checkbox',
            isPasswordConfirmed && 'password-verifier__checkbox--checked',
          ]"
        >
          <CheckIcon
            size="14"
            v-if="isPasswordConfirmed"
            class="password-verifier__check"
          />
        </div>
      </div>
      <span
        :class="[
          'password-verifier__detail',
          isPasswordConfirmed && 'password-verifier__detail--valid',
        ]"
        >Password is confirmed</span
      >
    </div>
  </div>
</template>

<script>
import { CheckIcon } from 'vue-feather-icons'
import {
  passwordHasLowercase,
  passwordHasUppercase,
  passwordHasANumber,
  passwordHasCorrectLength,
} from '@/helpers/isPasswordValid'

export default {
  name: 'PasswordVerifierWidget',
  components: {
    CheckIcon,
  },
  props: {
    password: {
      type: String,
      required: true,
    },
    isPasswordConfirmed: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hasLowercase() {
      return passwordHasLowercase(this.password)
    },
    hasNumber() {
      return passwordHasANumber(this.password)
    },
    hasUppercase() {
      return passwordHasUppercase(this.password)
    },
    hasLength() {
      return passwordHasCorrectLength({
        value: this.password,
        requiredLength: 8,
      })
    },
  },
}
</script>

<style lang="scss">
.password-verifier {
  color: var(--white);
  font-family: var(--font-regular);
  display: flex;
  flex-wrap: wrap;
  @include mobile {
    padding: 5px 0 15px 10px;
  }
  &__item {
    width: 171px;
    display: flex;
    align-items: center;
    margin: 0 20px 5px 0;
    height: 20px;
    white-space: nowrap;
  }
  &__detail {
    margin: 0;
    padding: 0;
    font-size: rem(14px);
    line-height: 20px;
    color: var(--perfect-gray);
    &--valid {
      color: var(--white);
    }
  }
  &__checkbox-wrapper {
    margin: 0 10px 0 0;
    position: relative;
  }
  &__checkbox {
    height: 20px;
    width: 20px;
    appearance: none;
    border: 1px solid var(--emperor-gray);
    border-radius: 5px;
    outline: none;
    transition-duration: 0.3s;
    background-color: transparent;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &--checked {
      border-color: var(--positive-light);
    }
  }
  &__check {
    pointer-events: none;
    stroke: var(--positive-light);
    padding-top: 1px;
  }
}
</style>
